import { asRecord, MAX_SHORT_FIELD, strField } from "./contact";

const NEWSLETTER_KINDS = ["product_updates", "technical_bulletin"] as const;
export type NewsletterKind = (typeof NEWSLETTER_KINDS)[number];

export const NEWSLETTER_LABELS: Record<NewsletterKind, string> = {
  product_updates: "Product updates",
  technical_bulletin: "Technical bulletin",
};

export interface NewsletterRequest {
  email: string;
  newsletters: string[];
  phone: string;
  elapsedMs: number;
}

export function isNewsletterKind(value: string): value is NewsletterKind {
  return NEWSLETTER_KINDS.includes(value as NewsletterKind);
}

export function normalizeNewsletterKinds(values: string[]): NewsletterKind[] {
  return [...new Set(values.filter(isNewsletterKind))].sort() as NewsletterKind[];
}

export function parseNewsletterRequest(raw: unknown): NewsletterRequest {
  const record = asRecord(raw);
  return {
    email: strField(record, "email"),
    newsletters: Array.isArray(record.newsletters)
      ? record.newsletters.filter((value): value is string => typeof value === "string")
      : [],
    phone: strField(record, "phone"),
    elapsedMs: typeof record.elapsedMs === "number" ? record.elapsedMs : NaN,
  };
}

/** Validate a request before sending consent mail.
 *
 * Use this at every subscription entry point so malformed or unknown list
 * choices never become capabilities inside a confirmation token. */
export function validateNewsletterRequest(data: NewsletterRequest): string[] {
  const errors: string[] = [];
  const email = data.email.trim();
  if (!/^[^\s@<>()[\],;:"\\]+@[^\s@<>()[\],;:"\\]+\.[^\s@<>()[\],;:"\\]+$/.test(email)) {
    errors.push("A valid email address is required.");
  }
  if (email.length > MAX_SHORT_FIELD) errors.push("Email is too long.");
  if (data.newsletters.length === 0) errors.push("Choose at least one newsletter.");
  if (data.newsletters.some((value) => !isNewsletterKind(value))) {
    errors.push("Invalid newsletter selection.");
  }
  return errors;
}
